module.exports = __webpack_public_path__ + "assets/img/email-c25b739b.png";